var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebarWindow bigSidebarWindow" }, [
    _c("div", { staticClass: "sidebarWindowTitle layers-title" }, [
      _c("div", { staticClass: "layertitleTextContainer" }, [
        _c("span", { staticClass: "layerTitle" }, [
          _vm._v(_vm._s(_vm.$tc("Layer", 2)))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { margin: "5px 12px 10px 10px" } },
      [
        _c(
          "v-layout",
          {
            staticStyle: { "margin-top": "25px" },
            attrs: { row: "", "justify-start": "", "align-center": "" },
            on: { click: _vm.toggleShowTabNetworkLayers }
          },
          [
            _c(_vm.networkLayersIcon, {
              tag: "component",
              staticClass: "searchSVG"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "layers-filter" }, [
              _vm._v(_vm._s(_vm.$t("FilterByNetwork")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("v-text-field", {
          staticClass: "layer-search",
          attrs: {
            "prepend-inner-icon": "search",
            label: _vm.$t("Search"),
            placeholder: _vm.$t("Search"),
            "single-line": ""
          },
          model: {
            value: _vm.search,
            callback: function($$v) {
              _vm.search = $$v
            },
            expression: "search"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layers-tree scroll-fire-fox" },
      [
        _c("v-treeview", {
          attrs: {
            "open-on-click": "",
            items: _vm.layersMap,
            search: _vm.search,
            "item-key": "id",
            "item-text": "label",
            "return-object": "",
            id: "layers-sidebar-tree",
            open: _vm.openMapLayer,
            "expand-icon": "mdi-chevron-down",
            "on-icon": "mdi-checkbox-marked",
            "off-icon": "mdi-checkbox-blank-outline"
          },
          on: { "update:open": _vm.updateExpandedMapLayer },
          scopedSlots: _vm._u([
            {
              key: "prepend",
              fn: function(ref) {
                var item = ref.item
                var open = ref.open
                return [
                  !(item.label === "Maps")
                    ? _c("v-checkbox", {
                        attrs: {
                          "input-value":
                            JSON.stringify(_vm.selectedMapLayer) ===
                            JSON.stringify(item),
                          color: "#4fa2b7"
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateSelectedLayersMap(item)
                          }
                        }
                      })
                    : _vm._e()
                ]
              }
            },
            {
              key: "label",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "layer-item-label" }, [
                    _c("span", { staticClass: "labelSpan" }, [
                      _vm._v(_vm._s(item.label) + " ")
                    ])
                  ])
                ]
              }
            }
          ])
        }),
        _vm._v(" "),
        _c("v-treeview", {
          attrs: {
            value: _vm.tree,
            open: _vm.openLayers,
            "open-on-click": "",
            items: _vm.allLayers,
            search: _vm.search,
            selectable: "",
            "item-key": "id",
            "item-text": "label",
            "return-object": "",
            id: "layers-sidebar-tree",
            "expand-icon": "mdi-chevron-down",
            "on-icon": "mdi-checkbox-marked",
            "off-icon": "mdi-checkbox-blank-outline",
            "indeterminate-icon": "mdi-minus-box"
          },
          on: {
            input: _vm.updateSelectedLayers,
            "update:open": _vm.updateExpandedLayers
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "layer-item-label" }, [
                    _c(
                      "span",
                      {
                        staticClass: "labelSpan",
                        attrs: {
                          title: item.translatable_label
                            ? _vm.$tc(item.translatable_label, 2)
                            : item.label
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            item.translatable_label
                              ? _vm.$tc(item.translatable_label, 2)
                              : item.label
                          )
                        )
                      ]
                    )
                  ])
                ]
              }
            },
            {
              key: "append",
              fn: function(ref) {
                var item = ref.item
                var selected = ref.selected
                return [
                  item.has_geoserver_label_button
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-0",
                          attrs: {
                            icon: "",
                            text: "",
                            "x-small": "",
                            disabled: !selected
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleGeoserverLabel(item)
                            }
                          }
                        },
                        [
                          item.has_geoserver_label_button
                            ? _c(
                                "v-icon",
                                {
                                  attrs: {
                                    size: "12",
                                    color: _vm.isGeoserverLabelActive(
                                      item,
                                      selected
                                    )
                                      ? "accent"
                                      : "secondary darken-1"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.isGeoserverLabelActive(
                                          item,
                                          selected
                                        )
                                          ? "mdi-tag"
                                          : "mdi-tag-outline"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20767e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20767e8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SideBar/SidebarWindows/Layers/Layers.vue
// module id = null
// module chunks = 